import { render, staticRenderFns } from "./StocktakingList.vue?vue&type=template&id=07a686bb&"
import script from "./StocktakingList.vue?vue&type=script&lang=js&"
export * from "./StocktakingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports